export function TabSetPlaceholder() {
  return <>Add widget via MENU</>;
}
